'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n'], ['\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _slide = require('../slide');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEY_ESC = 27;

var FullscreenMode = function (_React$Component) {
  _inherits(FullscreenMode, _React$Component);

  function FullscreenMode(props) {
    _classCallCheck(this, FullscreenMode);

    var _this = _possibleConstructorReturn(this, (FullscreenMode.__proto__ || Object.getPrototypeOf(FullscreenMode)).call(this, props));

    _this.onResize = function () {
      _this.setState({
        screenWidth: document.documentElement.clientWidth,
        screenHeight: document.documentElement.clientHeight
      });
    };

    _this.onKeyDown = function (event) {
      if (event.keyCode === KEY_ESC) {
        _this.props.toggleFullscreen();
      }
    };

    _this.state = {
      screenWidth: document.documentElement.clientWidth,
      screenHeight: document.documentElement.clientHeight
    };
    return _this;
  }

  _createClass(FullscreenMode, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.onResize();
    }

    // TODO: implement an event throttling

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.onResize);
      document.body.addEventListener('keydown', this.onKeyDown);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
      document.body.removeEventListener('keydown', this.onKeyDown);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          slide = _props.slide,
          slideWidth = _props.slideWidth,
          slideHeight = _props.slideHeight;


      var screenGeometry = {
        width: this.state.screenWidth,
        height: this.state.screenHeight
      };

      return _react2.default.createElement(
        Fullscreen,
        null,
        _react2.default.createElement(
          Layer,
          null,
          _react2.default.createElement(_slide.Slide, {
            slide: slide,
            key: slide.index,
            width: slideWidth,
            height: slideHeight,
            fitInto: screenGeometry
          })
        )
      );
    }
  }]);

  return FullscreenMode;
}(_react2.default.Component);

var Layer = _styledComponents2.default.div(_templateObject);

var Fullscreen = _styledComponents2.default.div(_templateObject2);

exports.default = FullscreenMode;